export default {
  loading: false,
  adminOperations: [],
  adminLogs: [],
  pagination: {},
}
